import VColumnTime from './index.vue';

export default {
  install: (Vue) => Vue.component('VColumnTime', VColumnTime),
};
